import React, { Component } from "react";
import { Modal, Input, Form, Button, Col, Row, message } from "antd";
import { createHospital } from "../../services";
import { showErrorNotification, showSuccessNotification } from "../../helpers";
import NumericInput from "../NumericInput";
const FormItem = Form.Item;

class AddEditHospitalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      countryCode: "91",
      phoneNumber: "",
      password: "",
      email: "",
      isProcessing: false
    };
  }

  handleInputChange = (value, name) => {
    this.setState({ [name]: value });
  };

  handlePhoneNumberChange = value => {
    this.setState({ phoneNumber: value });
  };

  handleSubmit = e => {
    if (e) e.preventDefault();
    const { name, countryCode, phoneNumber, password, email } = this.state;

    if (!name || !phoneNumber || !password || !email) {
      message.error("Please add all fields");
      return false;
    }
    this.setState({ isProcessing: true });
    const params = {
      user_signup_form: {
        signed_up_as: "hospital_clinic",
        country_code: countryCode,
        phone_number: phoneNumber,
        password: password,
        name: name,
        timezone: "Asia/Kolkata",
        email: email,
        account: "clinic"
      }
    };
    createHospital(params)
      .then(response => {
        if (response.data.success) {
          showSuccessNotification("Hospital created successfuly");
          this.props.toggleModal();
          this.props.fetchClinicData();
        } else {
          showErrorNotification(response.data.errors[0].title);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const { name, phoneNumber, password, email, isProcessing } = this.state;
    const { showModal, toggleModal } = this.props;
    return (
      <Modal
        visible={showModal}
        title={"Add Hospital"}
        footer={null}
        onCancel={toggleModal}
        className="form-type-modal"
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem label="Hospital Name">
            <Input
              value={name}
              onChange={e => this.handleInputChange(e.target.value, "name")}
            />
          </FormItem>
          <FormItem label="Phone number">
            <NumericInput
              maxLength={10}
              value={phoneNumber}
              onChange={this.handlePhoneNumberChange}
            />
          </FormItem>
          <FormItem label="Email Address">
            <Input
              value={email}
              onChange={e => this.handleInputChange(e.target.value, "email")}
            />
          </FormItem>
          <FormItem label="Password">
            <Input.Password
              value={password}
              onChange={e => this.handleInputChange(e.target.value, "password")}
            />
          </FormItem>
          <FormItem>
            <Row type="flex" gutter={20}>
              <Col>
                <Button type="primary" htmlType="submit" loading={isProcessing}>
                  Submit
                </Button>
              </Col>
              <Col>
                <Button onClick={toggleModal}>Cancel</Button>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default AddEditHospitalModal;
